'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = require('./common');

exports.default = (0, _common.regex)('alpha', /^[a-zA-Z]*$/);


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/staging/shared/frontend/~/vuelidate/lib/validators/alpha.js
// module id = 1125
// module chunks = 0